module.exports = __webpack_public_path__ + "static/img/web1.835b7b4c.png";